import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { naviguer } from '../App';
import { chf, dateCourte, LIBELLE_STATUT } from '../utils/format';
import type { FactureImprimable } from '../types';

// Le relevé / la facture, prêt à imprimer (ou « Enregistrer en PDF » depuis le navigateur).
export function FactureImprimerPage({ id }: { id: number }) {
  const [f, setF] = useState<FactureImprimable | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.getFacture(id).then(setF).catch((e) => setError(e instanceof Error ? e.message : 'Échec du chargement'));
  }, [id]);

  if (error) return <div className="page"><div className="badge badge-err">{error}</div></div>;
  if (!f) return <div className="page"><div className="spinner" /></div>;

  return (
    <>
      <div className="releve-actions">
        <button className="btn" onClick={() => naviguer('participants', f.participant_id)}>← Retour à la fiche</button>
        <button className="btn btn-accent" onClick={() => window.print()}>Imprimer / PDF</button>
      </div>
      <div className="releve">
        <div className="releve-head">
          <div>
            <img src="/logo-eveil.svg" alt="Eveil" />
            <div className="releve-meta" style={{ marginTop: 8 }}>{f.emetteur.nom}<br />{f.emetteur.adresse}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <h1 className="releve-title">Relevé de participation</h1>
            <div className="releve-meta">N° {f.numero}<br />Période du {dateCourte(f.periode_du)} au {dateCourte(f.periode_au)}<br />Statut : {LIBELLE_STATUT[f.statut]}{f.emise_le ? ` · émis le ${dateCourte(f.emise_le)}` : ''}</div>
          </div>
        </div>

        <p>
          <b>{f.participant ? `${f.participant.prenom} ${f.participant.nom}` : `Participant·e ${f.participant_id}`}</b>
          {f.participant?.bailleur ? <><br />{f.participant.bailleur}{f.participant.contrat ? ` · contrat ${f.participant.contrat}` : ''}</> : null}
        </p>
        <p className="releve-meta">{f.emetteur.mention}</p>

        <table>
          <thead><tr><th>Date</th><th>Atelier</th><th className="num">CHF</th></tr></thead>
          <tbody>
            {f.lignes.map((l) => (
              <tr key={l.attendance_id}><td>{dateCourte(l.date)}</td><td>{l.atelier}</td><td className="num">{chf(l.tarif)}</td></tr>
            ))}
          </tbody>
          <tfoot>
            <tr><td colSpan={2}>Total — {f.lignes.length} séance{f.lignes.length > 1 ? 's' : ''}</td><td className="num">CHF {chf(f.montant)}</td></tr>
          </tfoot>
        </table>

        {f.note && <p className="releve-foot">{f.note}</p>}
        <p className="releve-foot">Merci de régler ce montant auprès de votre personne de référence (en espèces) ou selon les indications de la facture comptable qui vous est adressée.</p>
      </div>
    </>
  );
}
